import React from "react";
import { GridItemLabelValue } from "./GridItemLabelValue";

interface InvestmentCardLabelValueProps {
  label: string;
  value: string;
}
export const InvestmentCardLabelValue = ({
  value,
  label,
}: InvestmentCardLabelValueProps) => {
  return (
    <GridItemLabelValue
      labelItemProps={{
        className: "text-start sm:text-end",
      }}
      value={value}
      label={label}
    />
  );
};
